import { useEffect } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

function Contact2Us() {
  useEffect(() => {
    if (!document.getElementById("map")) return; // Ensure the map container exists

    const map = L.map("map").setView([50.813884, 4.938014], 10);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap contributors",
    }).addTo(map);

    const customIcon = L.icon({
      iconUrl: "https://cdn-icons-png.flaticon.com/128/684/684908.png", // Replace with your icon URL
      iconSize: [32, 32], // Size of the icon [width, height]
      iconAnchor: [16, 32], // Point of the icon that corresponds to marker's location
      popupAnchor: [0, -32], // Where the popup should appear relative to the icon
    });

    L.marker([50.813884, 4.938014],{ icon: customIcon })
      .addTo(map)
      .bindPopup("AsicFlow")
      .openPopup();

    return () => {
      map.remove(); // Cleanup when unmounting
    };
  }, []);

  return (
    <section className="py-5">
      <div className="container">
        <div className="container-fluid p-lg-0">
          <div className="row g-0 align-items-center">
            <div className="col-lg-6">
              <div className="col-lg-8 mx-auto">
                <span className="text-muted">🌍 Connect With Us</span>
                <h2 className="display-5 fw-bold">Let's Build the Future of Chip Design Together</h2>
                <p className="lead">
                    Need support with open-source chip design tools? Interested in collaborating? Or just want to explore the possibilities? Reach out—we'd love to hear from you!
                 </p>
                <form>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <input
                        className="form-control bg-light"
                        placeholder="Your name"
                        type="text"
                      />
                    </div>
                    <div className="col-md-12 mb-3">
                      <input
                        className="form-control bg-light"
                        placeholder="Your email"
                        type="text"
                      />
                    </div>
                    <div className="col-md-12 mb-3">
                      <textarea
                        className="form-control bg-light"
                        placeholder="Your message"
                        rows={4}
                      />
                    </div>
                    <div className="col-md-5 d-grid">
                      <button className="btn btn-primary" type="submit">
                        Send message
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            {/* Map Section */}
            <div className="col-lg-6">
              <div id="map" style={{ height: "600px", width: "100%" }}></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact2Us;
